import { useEffect, useState } from 'react';
import { listExpenseCategories, type ExpenseCategoryView } from '../expenses.api';

/** The whole category catalogue (a handful of rows): the form's select and the table's category filter. Empty until it loads. */
export function useExpenseCategories(): ExpenseCategoryView[] {
  const [categories, setCategories] = useState<ExpenseCategoryView[]>([]);

  useEffect(() => {
    let cancelled = false;
    listExpenseCategories()
      .then((rows) => {
        if (!cancelled) setCategories(rows);
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, []);

  return categories;
}
